import { clearUndefined, cloneDeep } from "./function.mjs";
import { isDefined } from "./guards.mjs";
import { has } from "./object.mjs";
export const isObject = (val) => toString.call(val) === "[object Object]";
export const isRegex = (val) => toString.call(val) === "[object RegExp]";
export const isArray = (val) => Array.isArray(val);
export const isNumber = (val) => typeof val === "number";
export const isNumeric = (val) => isNumber(val) || /^-?\d+(\.\d+)?$/.test(val);
export const isString = (val) => typeof val === "string";
export const isBoolean = (val) => typeof val === "boolean";
export const isFunction = (val) => typeof val === "function";
export const isBrowser = typeof window !== "undefined";
export const isArrayLike = (object) => {
  if (!object)
    return false;
  if (isString(object))
    return false;
  if (typeof object !== "object")
    return false;
  if (object.nodeType === 1)
    return !!object.length;
  if (object.length === 0)
    return true;
  if (object.length > 0) {
    return has(object, 0) && has(object, object.length - 1);
  }
  return false;
};
export const isEqual = (value, other) => {
  if (typeof value !== typeof other)
    return false;
  if (isArray(value) && isArray(other)) {
    return clearUndefined(value).sort().toString() === clearUndefined(other).sort().toString();
  }
  if (isObject(value) && isObject(other)) {
    return JSON.stringify(Object.entries(clearUndefined(value)).sort()) === JSON.stringify(Object.entries(clearUndefined(other)).sort());
  }
  return value === other;
};
export const isStrictEqual = (value, other) => {
  if (typeof value !== typeof other)
    return false;
  if (isArray(value) && isArray(other)) {
    return cloneDeep(value).sort().toString() === cloneDeep(other).sort().toString();
  }
  if (isObject(value) && isObject(other)) {
    return JSON.stringify(Object.entries(value).sort()) === JSON.stringify(Object.entries(other).sort());
  }
  return value === other;
};
export const isEmpty = (val) => {
  if (!isDefined(val))
    return true;
  if (isString(val) && val.trim() === "")
    return true;
  if (isNumber(val) && (val === 0 || Number.isNaN(val)))
    return true;
  if (isBoolean(val) && val === false)
    return true;
  if (isArray(val) && val.length === 0)
    return true;
  if (isObject(val)) {
    const values = Object.values(clearUndefined(val));
    return values.length === 0;
  }
  return false;
};
export const isExist = (val) => !isEmpty(val);
